import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];
  static classes = ["active", "inactive"];

  select({ params: { name } }) {
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.name !== name);
    });

    this.tabTargets.forEach((tab) => {
      const selected = tab.dataset.tabsNameParam === name;
      tab.setAttribute("aria-selected", selected);
      tab.classList.toggle(this.activeClass, selected);
      tab.classList.toggle(this.inactiveClass, !selected);
    });
  }
}
